import { VignetteType } from '@eservices/shared/constant';
import { API } from '@eservices/shared/type';
import { Col, Row } from 'antd';
import Barcode from 'react-barcode';
import styled from 'styled-components';
import Logo from '../../assets/images/login-logo.svg';
import { Fonts } from '../../constants';
import {
    CheckboxContainer,
    CheckedBox,
    ColonContainer,
    DateLabelContainer,
    DateLineContainer,
    DatePartContainer,
    ImageContainer,
    Label,
    TitleLabel,
    VignetteTypeCheckContainer,
    VignetteTypeContainer,
    VignetteTypeText,
} from './Common';

const Container = styled.div`
    margin: 10px;
`;

const BarcodePartContainer = styled.div`
    text-align: center;
    img {
        max-width: 150px;
    }
`;

const DepartmentLabel = styled.div`
    text-align: left;
    font-family: ${Fonts.HURME4};
    font-size: 24px;
    margin-left: 10px;
`;

const VignetteTypeTitle = styled.div`
    padding: 5px;
    font-size: 10px;
    border-bottom: 2px solid black;
`;

const DepartmentErpIdLabel = styled.div`
    font-family: ${Fonts.HURME4_LIGHT};
    margin-top: 10px;
    margin-left: 20px;
    font-size: 10px;
`;

const generateBarcodeValue = (type: VignetteType, erpId: string) => {
    switch (type) {
        case VignetteType.REGISTERED:
            return `A$${erpId}`;
        case VignetteType.PRIOR:
            return `P$${erpId}`;
        case VignetteType.NON_PRIOR:
            return `N$${erpId}`;
    }
};

interface VignettePreviewProps {
    department: API.DepartmentListItem;
    type: VignetteType;
}

const VignettePreview: React.FC<VignettePreviewProps> = ({ department, type }) => {
    const BarcodePart = () => {
        return (
            <BarcodePartContainer>
                <ImageContainer>
                    <img src={Logo} />
                </ImageContainer>
                <div>
                    <Barcode
                        format="CODE39"
                        renderer="img"
                        value={generateBarcodeValue(type, department.erpId)}
                        displayValue={false}
                        height={55}
                    />
                </div>
                <DepartmentLabel>{department.name}</DepartmentLabel>
            </BarcodePartContainer>
        );
    };

    const VignetteTypePart = () => {
        return (
            <div>
                <VignetteTypeContainer>
                    <VignetteTypeTitle>
                        {type === VignetteType.REGISTERED ? (
                            <>
                                <Label>Aangetekende zendingen</Label>
                                <Label>Envois recommandés</Label>
                            </>
                        ) : (
                            <>
                                <Label>Post nationaal & internationaal</Label>
                                <Label>Courrier national & international</Label>
                            </>
                        )}
                    </VignetteTypeTitle>
                    <VignetteTypeCheckContainer>
                        <CheckboxContainer>{CheckedBox}</CheckboxContainer>
                        <VignetteTypeText>
                            {type === VignetteType.REGISTERED && (
                                <>
                                    <TitleLabel>Aangetekend</TitleLabel>
                                    <TitleLabel>Recommandé</TitleLabel>
                                </>
                            )}
                            {type === VignetteType.PRIOR && <TitleLabel>Prior</TitleLabel>}
                            {type === VignetteType.NON_PRIOR && <TitleLabel>Non Prior</TitleLabel>}
                        </VignetteTypeText>
                    </VignetteTypeCheckContainer>
                </VignetteTypeContainer>
                <DepartmentErpIdLabel>{department.erpId}</DepartmentErpIdLabel>
            </div>
        );
    };

    const DatesPart = () => {
        return (
            <DatePartContainer>
                <DateLineContainer>
                    <DateLabelContainer>
                        <Label>DATUM</Label>
                        <Label>DATE</Label>
                    </DateLabelContainer>
                    <ColonContainer>
                        <Label>:</Label>
                    </ColonContainer>
                </DateLineContainer>
                <DateLineContainer>
                    <DateLabelContainer>
                        <Label>AANTAL</Label>
                        <Label>NOMBRE</Label>
                    </DateLabelContainer>
                    <ColonContainer>
                        <Label>:</Label>
                    </ColonContainer>
                </DateLineContainer>
            </DatePartContainer>
        );
    };

    return (
        <Container>
            <Row justify="start">
                <Col span={8}>
                    <BarcodePart />
                </Col>
                <Col span={8}>
                    <VignetteTypePart />
                </Col>
            </Row>
            <Row justify="end">
                <Col span={8}>
                    <DatesPart />
                </Col>
            </Row>
        </Container>
    );
};

export default VignettePreview;
